import type { DiscoveredRouteModule } from '@/router/generator/types';

const AlreadyRegisteredView = () => import('@/views/error-pages/AlreadyRegisteredView.vue');
export const NAME_ALREADY_REGISTERED = 'AlreadyRegistered';
export const PATH_ALREADY_REGISTERED = '/already-registered';

export const route: DiscoveredRouteModule = {
  id: 'root.error.already_registered',
  scope: 'root',
  name: NAME_ALREADY_REGISTERED,
  path: PATH_ALREADY_REGISTERED,
  component: AlreadyRegisteredView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


